import { trackEvent } from "src/Amplitude";
import { Grid, Link, Typography, useTheme } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { Dispatch, useEffect, useState } from "react";
import { SubmitButton } from "src/components/forms/SubmitButton";
import api from "src/store/features/api";
import { onlyNumbers } from "src/utils/regex";
import * as Yup from "yup";
import { CustomInput } from "./CustomInputField";
import { SmsStyles } from "./styles/smsStyles";

export const UserInputModal = (props: {
  message: string;
  isSuccess: boolean;
  setSmsState: Dispatch<any>;
  setDialogState: Dispatch<any>;
}) => {
  const theme = useTheme();
  const classes = SmsStyles();
  const [postVerification, { isSuccess: verifySucess, isError: verifyError }] =
    api.useVerifySms2FaMutation();

  useEffect(() => {
    // set verify state
    if (verifySucess) props.setDialogState("normal");
    // reenter code
    if (verifyError) props.setSmsState("wrong code");
  }, [verifySucess, verifyError]);

  useEffect(() => {
    trackEvent(
      "Visit_Modal",
      {
        modal: "Get_Verification_Code",
      },
      "Submit_Verification_Code",
    );
  }, []);

  const submitCode = (values: any) => {
    postVerification({ twoFactorDto: { code: values.code } });
  };

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .min(6)
      .max(6)
      .matches(
        // eslint-disable-next-line no-useless-escape
        onlyNumbers,
        "Should only contain numbers",
      )
      .required("Verification code is required"),
  });

  const [requestNewCode, setRequestNewCode] = useState(false);

  useEffect(() => {
    // User can request a new code after 10 seconds
    let timeOut = setTimeout(() => {
      setRequestNewCode(true);
    }, 15000);
    return () => {
      clearTimeout(timeOut);
    };
  }, []);

  const handleClick = (skip: boolean) => {
    props.setSmsState("loading");
    setRequestNewCode(false);
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography color={props.isSuccess ? "#4caf50" : theme.palette.error.main}>
          {props.message}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Formik
          initialValues={{ code: "" }}
          onSubmit={submitCode}
          validationSchema={validationSchema}>
          <Form>
            <Typography mt={2} className={classes.fieldTitle}>
              Enter the verification code
            </Typography>
            <Field fullWidth as={CustomInput} name="code" placeholder="Code" />
            <Grid item xs={12} mt={2} justifyContent={"center"}>
              {requestNewCode && (
                <Typography sx={{ fontSize: "16px", fontWeight: "regular" }}>
                  {"If you haven't received the code"}
                  <Link
                    onClick={() => handleClick(false)}
                    sx={{
                      color: "#fc4c4c",
                      textDecoration: "none",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}>
                    {" click here "}
                  </Link>
                  {"to request a new one."}
                </Typography>
              )}
              <SubmitButton fullWidth style={{ height: "50px", marginTop: "8px" }} />
            </Grid>
          </Form>
        </Formik>
      </Grid>
    </>
  );
};
